<template>
  <div class="home" :style="{minHeight: bodyHeight + 'px'}">
    <router-view></router-view>
    <div class="copyright" :style="{backgroundColor: mobile ? '#f7f7f7' : ''}">© Copyright {{new Date().getFullYear()}} 国药励展展览有限公司. All rights reserved.</div>
  </div>
</template>

<script>

export default {
  name: 'ex-register',
  props: {},
  data () {
    return {
      arr: [{ id: 1, path: require('../../../assets/img/banner.png') }],
      enArr: [{ id: 1, path: require('../../../assets/img/banner.png') }],
      bodyHeight: "800px",
      mobile: false,
    };
  },
  created () {
    this.bodyHeight = window.innerHeight ? window.innerHeight : "800";
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.mobile = true;
    }
  },
}

</script>

<style lang="scss" scoped>
.home {
  background: #fff;
  overflow: hidden; 
}

.copyright {
  margin: 0 auto; 
  text-align: center;
  font-size: 12px;
  color: #999;
  padding: 0 20px 30px; 
}
</style>s
